import { AppThunk } from '../../../store/rootReducer';
import * as clusterActions from '../actions/cluster.actions';
import {
  baseClusterIdsSelector,
  selectedClusterIdsSelector,
} from '../selectors/cluster.selectors';
import { last } from 'lodash';
import { Cluster } from '../clustering.types';
import { selectNewCluster } from './select-new-cluster.thunk';

export const selectBaseClusters =
  (cluster: Cluster, isShiftKey = false, isCtrlKey = false): AppThunk =>
  async (dispatch, getState) => {
    const selectedIdSet = selectedClusterIdsSelector(getState());
    const selectedIds = Array.from(selectedIdSet);
    const clusterIds = baseClusterIdsSelector(getState());

    if (isShiftKey && isCtrlKey) {
      return;
    }

    if (
      isCtrlKey &&
      (!selectedIdSet.has(cluster.id) || selectedIdSet.size > 1)
    ) {
      const updatedIds = new Set(selectedIds);
      if (selectedIdSet.has(cluster.id)) {
        updatedIds.delete(cluster.id);
      } else {
        updatedIds.add(cluster.id);
      }

      dispatch(clusterActions.selectClusters({ clusterIds: updatedIds }));
    } else if (isShiftKey) {
      const lastSelectedId = last(selectedIds);
      const clusterIdIndex = clusterIds.findIndex(
        (currentId) => currentId === cluster.id,
      );
      const lastSelectedClusterIdIndex = clusterIds.findIndex(
        (currentId) => currentId === lastSelectedId,
      );
      const [firstIndex, lastIndex] =
        clusterIdIndex < lastSelectedClusterIdIndex
          ? [clusterIdIndex, lastSelectedClusterIdIndex]
          : [lastSelectedClusterIdIndex, clusterIdIndex];
      const clusterIdsToAdd = clusterIds.slice(firstIndex, lastIndex + 1);
      const updatedIds = [...selectedIds, ...clusterIdsToAdd];
      const updatedIdSet = new Set(updatedIds);

      dispatch(clusterActions.selectClusters({ clusterIds: updatedIdSet }));
    } else if (!selectedIdSet.has(cluster.id) || selectedIdSet.size > 1) {
      dispatch(selectNewCluster(cluster));
    }
  };
